
<template>
  <div>
    <el-dialog
      title="确认发布"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form ref="form" :model="dataForm" label-width="120px">
        <el-form-item label="发布策略">
          <el-radio-group v-model="dataForm.release" @change="radioChange">
            <el-radio label="1">立即发布</el-radio>
            <el-radio label="2">定时发布</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            :disabled="dataForm.release === '1'"
            type="datetime"
            placeholder="选择日期时间"
            v-model="dataForm.date"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="expireTimeOPtion"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span v-if="showError" class="error-msg">{{ errorMsg }}</span>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import httpMethods from '@/api/version/http.js'
export default {
  props: ['productId'],
  data() {
    return {
      showError: false,
      errorMsg: '',
      visible: false,
      versionId: '',
      versionNumber: '',
      content: '',
      dataForm: {
        date: '',
        release: '1'
      },
      expireTimeOPtion: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    }
  },
  methods: {
    init(info) {
      this.showError = false
      this.visible = true
      this.content = info.versionremark
      this.versionId = info.id
      this.versionNumber = info.versionNumber
    },
    radioChange() {
      if (this.dataForm.release === '1') {
        this.dataForm.date = ''
      }
    },
    // 确认
    onSubmit() {
      this.showError = false
      if (this.dataForm.release === '1') {
        // 立即发布
        this.publish()
      } else {
        // 定时发布
        const current = new Date() // 当前服务器的时间
        const currenttime = current.getTime()
        const releasetime = new Date(this.dataForm.date).getTime()
        const time = (releasetime - currenttime) / 60000 // 定时发布时间和当前服务器的时间差

        if (time > 5) {
          this.pulishSelectTime()
        } else {
          this.showError = true
          this.errorMsg = '发布时间距离当前时间需大于5分钟'
        }
      }
    },
    publish() {
      // 立即发布
      const data = {
        productId: this.productId,
        versionNumber: this.versionNumber,
        type: '1',
        startTime: ''
      }
      httpMethods
        .releaseVersion(data)
        .then((res) => {
          if (data && res.resp_code === 0) {
            this.visible = false
            this.$message.success('发布成功')
            this.$emit('refreshDataList')
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    pulishSelectTime() {
      // 定时发布
      const data = {
        productId: this.productId,
        versionNumber: this.versionNumber,
        type: '2',
        startTime: this.dataForm.date
      }
      httpMethods
        .releaseVersion(data)
        .then((res) => {
          if (data && res.resp_code === 0) {
            this.visible = false
            this.$message.success('定时发布成功')
            this.$emit('refreshDataList')
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item__content {
  text-align: center;
}
.error-msg {
  color: red;
  font-size: 12px;
  margin-right: 20px;
}
</style>
